export const dataLayerPagesEnum = {
  TICKETS_HOME_PAGE: 'step1',
  TICKETS_MERCHANDISING: 'step2',
  TICKETS_ASSIGN: 'step3',
  TICKETS_RECAP: 'step4',
  TICKETS_CHECKOUT: 'step5',
  MY_TICKETS_EDIT: 'my-tickets-edit',
  MY_TICKETS: 'my-tickets',
  MY_ORDERS: 'my-orders',
  ERROR_ORDER: 'order-error',
};

export const setVirtualPageDataLayer = (pageUrl) => {
  if (pageUrl) {
    const url = `${location.protocol}//${location.host}${location.pathname}`;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'VirtualPageviewEvent',
      VPpageUrl: `${url}/${pageUrl}`,
    });
  }
};

export const setVirtualPageView = ({ params, pageTitle }) => {
  if (params && pageTitle) {
    const url = `${location.protocol}//${location.host}${location.pathname}`;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'virtualPageview',
      pageUrl: `${url}${params}`,
      pageTitle: `${pageTitle}`,
    });
  }
};

export const setExhibitorLayerEvent = ({
  event = 'contact_exhibitor',
  exhibitorName,
}) => {
  if (exhibitorName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: `${event}`,
      exhibitor_name: `${exhibitorName}`,
    });
  }
};
export const setMapLayerEvent = ({
  event = 'popup_open',
  popup_name = 'salone_del_mobile_map',
  exhibitorName,
}) => {
  if (exhibitorName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: `${event}`,
      popup_name: `${popup_name}`,
      exhibitor_name: `${exhibitorName}`,
    });
  }
};

export const setECommerceDataLayer = ({
  items = [],
  event = 'add_to_cart',
  transactionId = undefined,
  totalMount = undefined,
}) => {
  if (items?.length) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: event,
      ecommerce: {
        currency: 'EUR',
        ...(transactionId && {
          transaction_id: transactionId,
        }),
        ...(totalMount && {
          value: totalMount,
        }),
        items: items,
      },
    });
  }
};

export const parseProductForDataLayer = ({
  product,
  idx,
  quantity,
  isMerch,
}) => ({
  item_id: product.id || '',
  item_name: product.description || '',
  price: product.prices?.[0]?.value || 0,
  currency: product.prices?.[0]?.currency || 'EUR',
  item_category: isMerch ? 'catalogo' : 'biglietti',
  item_list_name: isMerch ? 'catalogo' : 'biglietti',
  index: idx,
  quantity: quantity,
  item_brand: 'Salone del Mobile',
});
